import React, { useEffect } from "react";
import { observer } from "mobx-react";
import AppWorkspaceContainer from "./app/components/AppWorkspaceContainer";
import { BOOTSTRAP_SCRIPT_ID } from "./app/helpers/constants";
import { ToastProvider, bindToastApi, useToast } from "./ui/toast";

// The SPA owns "/", the coin pages ("/usdc-to-btc-lightning" …) and each swap's
// page ("/o/<token>") — exactly the pages app/index.html.erb renders, which are
// the ones carrying the bootstrap JSON. Marketing/legal ERB pages never mount it.
const isAppPage = (): boolean => document.getElementById(BOOTSTRAP_SCRIPT_ID) != null;

const ToastBinder: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { show } = useToast();
  useEffect(() => {
    bindToastApi(show);
  }, [show]);
  return <>{children}</>;
};

const AppContainer: React.FC = observer(() => {
  return (
    <ToastProvider>
      <ToastBinder>
        {isAppPage() ? <AppWorkspaceContainer /> : null}
      </ToastBinder>
    </ToastProvider>
  );
});

export default AppContainer;
